import { createGlobalStyle } from "styled-components";
import {
  SpaceMonoBold,
  SpaceMonoRegular,
  WorkSansBold,
  WorkSansLight,
  WorkSansMedium,
  WorkSansRegular,
  WorkSansSemiBold,
  urlMainFont400,
  urlMainFont500,
  urlMainFont600,
  urlMainFont700,
} from "assets/fonts/fonts";

const GlobalStyles = createGlobalStyle`
  @font-face {
      font-family: 'SpaceMonoBold';
      src: local('SpaceMonoBold'), url(${SpaceMonoBold}) format('truetype');
  }
  @font-face {
      font-family: 'SpaceMonoRegular';
      src: local('SpaceMonoRegular'), url(${SpaceMonoRegular}) format('truetype');
  }

  @font-face {
      font-family: 'WorkSansBold';
      src: local('WorkSansBold'), url(${WorkSansBold}) format('truetype');
  }
  @font-face {
      font-family: 'WorkSansLight';
      src: local('WorkSansLight'), url(${WorkSansLight}) format('truetype');
  }
  @font-face {
      font-family: 'WorkSansMedium';
      src: local('WorkSansMedium'), url(${WorkSansMedium}) format('truetype');
  }
  @font-face {
      font-family: 'WorkSansRegular';
      src: local('WorkSansRegular'), url(${WorkSansRegular}) format('truetype');
  }
  @font-face {
      font-family: 'WorkSansSemiBold';
      src: local('WorkSansSemiBold'), url(${WorkSansSemiBold}) format('truetype');
  }

  @font-face {
    font-family: "Pretendard-400";
    src: local('Pretendard400'), url(${urlMainFont400}) format('opentype');
  }
  @font-face {
    font-family: "Pretendard-500";
    src: local('Pretendard500'), url(${urlMainFont500}) format('opentype');
  }
  @font-face {
    font-family: "Pretendard-600";
    src: local('Pretendard400'), url(${urlMainFont600}) format('opentype');
  }
  @font-face {
    font-family: "Pretendard-700";
    src: local('Pretendard700'), url(${urlMainFont700}) format('opentype');
  }

  :root {
    --brand-color: #526557;
    --hint-color:#D7E1DA;
    --main-border: #526557;
    --active-border-color: #4096ff; 
    --sub-background: #F2F2EB;
    --grey-background: #BDBDBD;
    --light-color: #FFFFFF;
    --link-color: #3478F6;
    --text-color: #526557;
    --font-400: "Pretendard-400";
    --font-500: "Pretendard-500";
    --font-600: "Pretendard-600";
    --font-700: "Pretendard-700";
  }
  /* HTML5 display-role reset for older browsers */
  article, aside, details, figcaption, figure, 
  footer, header, hgroup, menu, nav, section {
    display: block;
  }
  body {
    line-height: 1;
  }
  ol, ul {
    list-style: none;
  }
  blockquote, q {
    quotes: none;
  }
  blockquote:before, blockquote:after,
  q:before, q:after {
    content: '';
    content: none;
  }
  table {
    border-collapse: collapse;
    border-spacing: 0;
  }
  /* end reset css*/
  * {
    margin: 0;
    box-sizing: border-box;
    /* font-family: var(--font-400); */
  }
  body {
    margin: 0;
    padding: 0;
    background-color: #F2F2EB;
    color: var(--text-color);
    /* font-size: 14px; */
    font-family: -apple-system, "Pretendard-400", "Segoe UI", "Roboto", "Oxygen",
    "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue",
    sans-serif;
  }
  img {
    max-width: 100%;
    height: auto;
  }
  /* html {
    font-family: 'Work Sans', sans-serif;
  } */
  .ant-layout {
    min-height: 100vh;
    overflow: hidden;
  }
  .title-button-container {
    display: flex;
    justify-content: space-between;
    .ant-btn {
      margin: 0 30px;
    }
  }
  .main-title {
    font-size: 32px;
    font-style: normal;
    font-family: var(--font-400);
    color: var(--text-color);
    padding:0 30px;
    line-height: 160%;
  }
  .ant-input {
    &::placeholder {
      font-size: 16px;
      color: #bfbfbf !important;
    }
  }
  .ant-input-affix-wrapper {
    border-color: var(--brand-color);
  }
  .form-input {
    height: 46px;
    border-radius: 20px;
    font-size: 16px;
  }
  .ant-select {
    width: 100%;
    /* border-color: #bfbfbf !important;
    .ant-select-selector {
      border-color: #bfbfbf !important;
    } */
    .ant-select-selection-placeholder {
      color: #b5b5b0 !important;
      font-size: 16px !important;
      font-family: var(--font-400) !important;
    }
  }
  .ant-form-item {
    .ant-input-prefix {
      margin-inline-end: 12px;
    }
  }
  .ant-form-item-explain-error {
    font-size: 12px;
  }
  .tox-notifications-container, .tox-statusbar__branding, .tox-promotion{
    display: none !important;
  }
  .ant-select {
    .ant-select-selection-item {
      padding-inline-end: 45px;
    }
    .ant-select-clear {
      right: 40px;
    }
  }

  .ant-table-wrapper .ant-table-pagination {
    text-align: center;
    display: flex;
    justify-content: center;
    margin-top: 30px;
  }
  .ant-tooltip {
    display: none;
  }
  /* :where(.css-dev-only-do-not-override-fpg3f5).ant-table-wrapper .ant-table-column-sorters::after {
    position: static;
  } */
  .ant-table {
    .ant-table-column-title {
      min-width: max-content;
    }
  }
  .ant-table-wrapper .ant-table-column-sorters::after {
      position: static !important;
    }
    .ant-tabs-tab-btn {
      font-size: 16px;
    }

    .ant-table-thead {
      th {
        font-size: 16px !important;
      }
    }
    .img-size {
      font-size: 14px;
      font-family: var(--font-500);
      margin-bottom: 10px;
    }
    .brand-option {
    display: flex;
    gap: 5px;
    align-items: center;
    /* &.disabled {
      opacity: 0.5;
      cursor: not-allowed;
      pointer-events: none;
      &.img {
        opacity: 0.5;
      cursor: not-allowed;
      pointer-events: none;
      }
    } */
    .brand-name {
    text-overflow: ellipsis;
    max-width: 100%;
    overflow: hidden;
  }
  }
  td.ant-table-cell {
    background: transparent !important;
}
.tb-center {
  &.ant-table-wrapper .ant-table-thead >tr>th {
    text-align: center;
  }
  &.ant-table-wrapper .ant-table-tbody >tr >td {
    text-align: center;
  }
}
/*
! tailwindcss v3.3.3 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}



html {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */
  -moz-tab-size: 4; /* 3 */
  -o-tab-size: 4;
     tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
}



body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/* p {
  font-size: 16px;
} */

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}



code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-size: 1em; /* 2 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}



sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}



:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}



::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden] {
  display: none;
}
.ant-btn-primary {
    background-color: #4096ff;
    color: #fff
  }

.headings {
  padding: 80px 30px 0 30px;
}
.main-headings {
    font-size: 28px;
    font-family: var(--font-500);
    /* margin-bottom: 4px; */
  }
  .sub-headings {
    font-size: 16px;
  }
.antd-center-table {
  &.ant-table-wrapper .ant-table-thead > tr > th {
    text-align: center;
  }
  &.ant-table-wrapper .ant-table-tbody > tr > td {
    text-align: center;
  }
}
.editable-cell-value-wrap  {
  /* transition: all 0.3s; */
  cursor: pointer;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 !important;
  &.disabled {
    cursor: default;
  }
}
.editable-row:hover .editable-cell-value-wrap:not(.disabled) {
    padding: 4px 11px;
    border: 1px solid #d9d9d9;
    border-radius: 2px;
}
`;

export default GlobalStyles;
